import { useEffect, useRef, useState } from 'react';

export interface ITokenString {
    hasToken: boolean;
    tokenFor: string;
}

export function useHasTokenString(tokenField: string): ITokenString {
    const [tokenString, setTokenString] = useState('');
    const checkTokenString = useRef(0);

    useEffect(() => {
        checkTokenString.current = window.setInterval(() => {
            const element: HTMLInputElement | HTMLTextAreaElement | null = document.querySelector(
                '[name="' + tokenField + '"]',
            );
            if (!element) {
                return;
            }
            if (element.tagName == 'INPUT') {
                setTokenString(element.value);
            } else {
                setTokenString(element.innerText);
            }
        }, 1000);

        return () => window.clearInterval(checkTokenString.current);
    }, [tokenField]);

    const processTokenString = (s: string): ITokenString => {
        const tmp = s.match(/[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]+/g);
        const email = tmp ? tmp[0] : '';
        return {
            hasToken: s.length > 0,
            tokenFor: email,
        };
    };

    const [tokenData, setTokenData] = useState<ITokenString>(processTokenString(tokenString));
    useEffect(() => {
        setTokenData(processTokenString(tokenString));
    }, [tokenString]);

    return tokenData;
}
